import { render, staticRenderFns } from "./comm.vue?vue&type=template&id=795d591c&scoped=true&"
import script from "./comm.vue?vue&type=script&lang=js&"
export * from "./comm.vue?vue&type=script&lang=js&"
import style0 from "./comm.vue?vue&type=style&index=0&id=795d591c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "795d591c",
  null
  
)

export default component.exports